import React from "react";
import { useSelector } from "react-redux";
import { lookupSelector } from "../../redux/lookupSlice";
import LabelRadio from "../Form/LabelRadio";

const CurrentUsesLabel = ({ setUse }) => {
  const lookup = useSelector(lookupSelector);
  return (
    <>
      <ul className="listUses list-unstyled">
        {lookup.currentUse.map((list) => (
          <li key={list.id}>
            <LabelRadio
              setUse={setUse}
              uses={list.id}
              fieldId={list.id}
              name={list.type}
            />
          </li>
        ))}
      </ul>
    </>
  );
};

export default CurrentUsesLabel;
